module.exports = __webpack_public_path__ + "img/LifePassTip-1_Animationv2.534c802a.gif";